export const ADD_EMPLOYEE_TO_HR_MODULE = 'Do you want to add this employee to HR module?';
